import { css } from 'linaria';

export const headerSection = css`
  position: relative;
  width: 100%;
  margin-bottom: 80px;

  @media (--to-desktop) {
    margin-bottom: 48px;
  }
`;

export const headerImage = css`
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 327px;

  @media (--to-desktop) {
    position: unset;
    height: 100%;
  }

  @media (--only-tablet) {
    margin-bottom: 32px;
  }

  @media (--only-mobile) {
    margin-bottom: 4px;
  }
`;

export const headerContent = css`
  width: 630px;
  margin: 55px 0 16px;

  @media (--to-desktop) {
    width: 100%;
    margin: 0;
  }
`;

export const headerTitle = css`
  && {
    width: 530px;
    margin-bottom: 24px;

    @media (--to-desktop) {
      margin-bottom: 16px;
    }

    @media (--only-tablet) {
      width: 550px;
    }

    @media (--only-mobile) {
      width: 100%;
      font-size: 28px;
      line-height: 34px;
    }
  }
`;

export const headerText = css`
  && {
    margin-bottom: 40px;

    @media (--only-desktop) {
      width: 373px;
      margin-bottom: 24px;
    }

    @media (--only-desktop) {
      line-height: 28px;
    }

    @media (--only-tablet) {
      margin-bottom: 32px;
      line-height: 28px;
    }

    @media (--only-mobile) {
      margin-bottom: 24px;
    }
  }
`;

export const headerButton = css`
  && {
    @media (--only-tablet) {
      padding: 10px 22px;
      font-size: 16px;
      line-height: 24px;
    }

    @media (--only-mobile) {
      width: 100%;
    }
  }
`;
